import React from "react";

const Badge = ({ children, color = "gray", size = "sm" }) => {
  const colors = {
    gray: "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400",
    primary:
      "bg-primary-100 text-primary-700 dark:bg-primary-900/30 dark:text-primary-400",
    green:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400",
    red: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
    yellow:
      "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
    cyan: "bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400",
    violet:
      "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400",
  };
  const sizes = {
    xs: "text-xs px-2 py-0.5",
    sm: "text-xs px-2.5 py-1",
    md: "text-sm px-3 py-1",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${colors[color]} ${sizes[size]}`}
    >
      {children}
    </span>
  );
};

export default Badge;
